'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preview = exports.Present = exports.Live = exports.Elements = exports.Plugins = exports.Slide = undefined;

var _slide = require('@dekk/slide');

Object.defineProperty(exports, 'Slide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_slide).default;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deck = require('@dekk/deck');

var _deck2 = _interopRequireDefault(_deck);

var _speakerDeck = require('@dekk/speaker-deck');

var _speakerDeck2 = _interopRequireDefault(_speakerDeck);

var _paging = require('@dekk/paging');

var _paging2 = _interopRequireDefault(_paging);

var _url = require('@dekk/url');

var _url2 = _interopRequireDefault(_url);

var _localStorage = require('@dekk/local-storage');

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Plugins = _deck.Plugins;
exports.Elements = _deck.Elements;

/**
 * Flag to set presenter mode
 */

var _search$parse = _url.search.parse(window.location.href),
    _search$parse$present = _search$parse.present,
    present = _search$parse$present === undefined ? null : _search$parse$present,
    _search$parse$live = _search$parse.live,
    live = _search$parse$live === undefined ? null : _search$parse$live,
    _search$parse$preview = _search$parse.preview,
    preview = _search$parse$preview === undefined ? null : _search$parse$preview;

var Live = exports.Live = function Live(_ref) {
  var children = _ref.children;
  return live !== null && _react2.default.createElement(
    _react2.default.Fragment,
    null,
    children
  );
};
var Present = exports.Present = function Present(_ref2) {
  var children = _ref2.children;
  return present !== null && _react2.default.createElement(
    _react2.default.Fragment,
    null,
    children
  );
};
var Preview = exports.Preview = function Preview(_ref3) {
  var children = _ref3.children;
  return preview !== null && _react2.default.createElement(
    _react2.default.Fragment,
    null,
    children
  );
};

/**
 * A preconfigured Deck with paging, URLs,
 * a presenter mode that can be enabled via the search query `?present=true`
 * and
 * a live mode that can be enabled via the search query `?live=true`
 * @param {Object} props
 *   The properties
 * @param {(Slide|Slide[]|Elements|Elements[]|Plugins|Plugins[])} props.children
 * @param {?(String|Array)} [props.mixin='']
 * @param {number} props.timer
 * @param {number} [props.timerWarning=0]
 *
 * @return {(Deck|SpeakerDeck)}
 */
var Dekk = function Dekk(props) {
  // Render the Speaker Deck
  if (present) {
    return _react2.default.createElement(
      _speakerDeck2.default,
      props,
      _react2.default.createElement(
        _deck.Plugins,
        null,
        _react2.default.createElement(_paging2.default, null),
        _react2.default.createElement(_url2.default, null),
        _react2.default.createElement(_localStorage2.default, { publish: true })
      ),
      props.children
    );
  }
  // Render the live Deck
  if (live) {
    return _react2.default.createElement(
      _deck2.default,
      props,
      _react2.default.createElement(
        _deck.Plugins,
        null,
        _react2.default.createElement(_localStorage2.default, { subscribe: true })
      ),
      props.children
    );
  }
  // Render the preview Deck
  if (preview === 0) {
    return _react2.default.createElement(
      _deck2.default,
      props,
      _react2.default.createElement(
        _deck.Plugins,
        null,
        _react2.default.createElement(_localStorage2.default, { subscribe: true })
      ),
      props.children
    );
  }
  if (preview === 1) {
    return _react2.default.createElement(
      _speakerDeck.Preview,
      props,
      _react2.default.createElement(
        _deck.Plugins,
        null,
        _react2.default.createElement(_localStorage2.default, { subscribe: true })
      ),
      props.children
    );
  }
  // Otherwise render a default Deck
  return _react2.default.createElement(
    _deck2.default,
    props,
    _react2.default.createElement(
      _deck.Plugins,
      null,
      _react2.default.createElement(_paging2.default, null),
      _react2.default.createElement(_url2.default, null)
    ),
    props.children
  );
};

/**
 * @private
 */
Dekk.propTypes = {
  children: _propTypes2.default.node.isRequired,
  timer: _propTypes2.default.number.isRequired,
  timerWarning: _propTypes2.default.number,
  mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string])

  /**
   * @private
   */
};Dekk.defaultProps = {
  timerWarning: 0,
  mixin: ''
};

exports.default = Dekk;